<template>
  <GenericModal ref="filmOrCategoryModal" @modal-closed="$emit('modal-closed')">

    <template #header>
      <!-- film header -->
      <FilmCheckbox v-if="filmInfo && userStore.isLoggedIn()" :film_id="filmInfo.film_id"></FilmCheckbox>
      <h6 class="modal-title">
        {{titleText}}<sup class="footnote-indicator">{{titleFootnoteIndicator}}</sup><FilmReviewedIndicator v-if="filmInfo && userStore.isLoggedIn()" :film_id="filmInfo.film_id" :debug_film_name="filmInfo.film?.name"></FilmReviewedIndicator>
        <span class="bookmark"><FilmBookmark v-if="filmInfo && userStore.isLoggedIn()" :film_id="filmInfo.film_id"></FilmBookmark></span>
      </h6>
    </template>

    <ModalBodyForFilm v-if="filmInfo" :film_id="filmInfo.film_id" :link_location="link_location" @film-details-loaded="onFilmDetailsLoaded"></ModalBodyForFilm>
    <ModalContentForCategory v-if="categoryInfo" :category_name="categoryInfo.name" :ceremony="categoryInfo.ceremony" :link_location="link_location" @category-details-loaded="onCategoryDetailsLoaded"></ModalContentForCategory>

    <template #footer v-if="footnotes?.length">
      <div class="film-footnotes">
        <ol>
          <li v-for="(footnote, index) in footnotes" :key="`footnote_${index+1}`">
            {{footnote}}
          </li>
        </ol>
      </div>
    </template>

  </GenericModal>

</template>

<script>
import ModalBodyForFilm from "@/components/modal/ModalBodyForFilm.vue";
import ModalContentForCategory from "@/components/modal/ModalBodyForCategory.vue";
import FilmCheckbox from "@/components/FilmCheckbox.vue";
import {Film} from "@/film";
import FilmBookmark from "@/components/FilmBookmark.vue";
import FilmReviewedIndicator from "@/components/FilmReviewedIndicator.vue";
import {userStore} from "@/userStore";
import GenericModal from "@/components/modal/GenericModal.vue";

export default {
  name: "FilmOrCategoryModal",
  components: {
    GenericModal,
    FilmReviewedIndicator, FilmBookmark, FilmCheckbox, ModalContentForCategory, ModalBodyForFilm},
  props: ['category_name', 'ceremony', 'film_name', 'film_id', 'link_location'],
  emits: ['modal-closed'],
  computed: {
    userStore() {
      return userStore
    },
    titleText() {
      if ( this.filmInfo ) {
        let filmTitle = this.filmInfo.film?.name || this.film_name; // fallback to optional property;

        if ( this.filmInfo.film?.year ) {
          filmTitle += ` (${this.filmInfo.film.year})`
        }

        return filmTitle;

      } else if ( this.categoryInfo ) {
        return `${this.categoryInfo.name} | ${Film.getCeremonyHeaderText(this.categoryInfo.ceremony)}`;
      }
      return '';
    },
    titleFootnoteIndicator() {
      return this.filmInfo?.film?.footnotes?.reduce((accNumbers, curFootnote) => {
        const footnoteNum = 1 + this.footnotes.indexOf(curFootnote);
        if ( footnoteNum > 0 ) {
          return [...accNumbers, footnoteNum];
        }
        return accNumbers;
      }, []).join(',') || '';
    }
  },

  data() {
    return {
      categoryInfo: null,
      filmInfo: null,
      footnotes: null
    }
  },

  provide() {
    return {
      // allow children to close the modal (generally when a link takes the user to another page)
      closeModal: this.closeModal,

      // allow children to set new films or categories
      showFilmDetails: this.showFilmDetails,
      showCategoryDetails: this.showCategoryDetails,
    }
  },

  mounted() {
    if ( this.film_id ) {
      this.showFilmDetails(this.film_id);
    }
    this.showCategoryDetails(this.category_name, this.ceremony);
  },

  methods: {
    showFilmDetails(_film_id, _film_name=null) {
      this.categoryInfo = null;
      this.filmInfo = {
        film_id: _film_id,
        film_name: _film_name || undefined
      };
    },
    onFilmDetailsLoaded(_film, _footnotes) {
      if ( this.filmInfo ) {
        this.filmInfo.film = _film;
        this.footnotes = _footnotes;
      }
    },
    onCategoryDetailsLoaded(_films, _footnotes) {
      if ( this.categoryInfo ) {
        this.categoryInfo.films = _films;
        this.footnotes = _footnotes;
      }
    },
    closeModal() {
      this.$refs.filmOrCategoryModal.closeModal();
    },
    showCategoryDetails(_name, _ceremony) {
      //console.log(`setCategoryInfo(${_name}, ${_year})`);
      if ( _name && Number.isInteger(_ceremony) ) {
        this.categoryInfo = {name: _name, ceremony: _ceremony};
        this.filmInfo = null;
        return true;
      }
      return false;
    },
  }
}
</script>

<style scoped>

  .modal-title {
    padding-left: 10px;

    .footnote-indicator {
      /*margin-left: 0.1em;*/
      font-style: normal;
      font-size: 80%;
      font-weight: normal;
      color: var(--bs-secondary-color);
    }

    .bookmark {
      padding-left: 0.2em;
    }
  }

  .film-footnotes {

    color: var(--bs-secondary-color);
    width: fit-content;
    text-align: left;

    margin: 0;
    /*
    margin-top: 0.75em;
    margin-right: 0;
    margin-left: auto;
    */
    display: inline;
    font-size: x-small;
    padding-right: 1rem;

    li {
      font-style: italic;
      padding-top: 0.75em;
      line-height: 130%;
    }
  }

</style>